import resources from "@/libs/resources";

// 不加入vue state，节省性能，这个变量只有一个查询的作用
export let source = {};

export default {
    namespaced: true,
    state: () => ({
        mainuser: '',
        mainuser_type: '',
        mainuser_menu: [],

        mainuser_list: [],
        commonmenu: {},

        role_list: [],

        route_alive: true,
    }),
    mutations: {

        setRouteAlive: (state, value) => state.route_alive = value,

        /**
         * 初始化主账号以及菜单权限
         * @param {*} state
         * @param {*} data
         */
        initializeAuthMenu(state, { auth, user }) {
            source = resources.init(auth, user);

            state.role_list = auth;
            state.commonmenu = source.commonmenu;
            state.mainuser_list = source.typetable;
        },

        /**
         * 自动选择某主账号
         */
        autoSelectMainuser() {
            let 主账号类型 = Object.keys(source.typetable);

            let index = 0;
            if (主账号类型.includes('店铺')) {
                index = 主账号类型.indexOf('店铺'); //优先自动选择店铺
            }

            if (主账号类型.length > 0) {
                const 主账号列表 = source.typetable[主账号类型[index]];
                if (主账号列表.length > 0) {
                    this.commit('home/selectMainuser', { mainuser: 主账号列表[0], type: 主账号类型[index] });
                }
            }
        },

        /**
         * 选择某主账号
         * @param {*} state
         * @param {*} param1
         */
        selectMainuser(state, { mainuser, type }) {
            state.mainuser = mainuser;
            state.mainuser_type = type;
            state.mainuser_menu = source.mainuser_menu[mainuser];
        }
    },
    actions: {

        // setRouteAlive: ({ commit }) => commit('setRouteAlive',),

        switchRouteAlive({ commit, state }) {
            commit('setRouteAlive', !state.route_alive);
        }

    },
    module: {

    }
}